var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mescroll-vue',{attrs:{"up":_vm.getscrollData(),"down":_vm.mescrollDown},on:{"init":_vm.initScroll}},[_c('div',{attrs:{"id":"dataList"}},_vm._l((_vm.projectData),function(item,index){return _c('div',{key:index,on:{"click":function($event){return _vm.intoProject(item)}}},[_c('search-cell',{attrs:{"msg":_vm._f("formatData")(item)}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }